// @ts-strict-ignore
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Banner } from '@node-space/ui-components'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'

export interface UKRiskBannerProps {
  companyName?: string
}

export const UKRiskBanner = ({ companyName }: UKRiskBannerProps) => {
  const { t } = useTranslation()

  const intro = companyName
    ? `${companyName}, ${t('ukBanner.introLowercase')}`
    : t('ukBanner.intro')
  const message = t('ukBanner.message')
  const bannerText = `${intro} ${message}`

  return (
    <Banner variant="info" iconName="Info">
      {bannerText}{' '}
      <ExternalLink href={process.env.UK_INFO_BANNER_LINK}>{t('ukBanner.linkText')}</ExternalLink>
    </Banner>
  )
}
